import { BlockModule } from '@/website/blocks/common'
import ServerIcon from '@/website/components/core/icons/ServerIcon.vue'
import { Button } from '@/components/ui/button'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { defineComponent } from 'vue'

new BlockModule({
    selector: '.block-brunei-gov-website-disclaimer',
    vueComponent: defineComponent({
        components: {
            BnButton: Button,
            Collapsible,
            CollapsibleContent,
            CollapsibleTrigger,
            ServerIcon,
        },
    }),
})
